import { Injectable } from '@angular/core';
import { Tuna } from '../interfaces/tuna';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TunaPieceProcessCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/tunas-pieces-processes/' ;
  }

  // Create Tuna
  add(record: Tuna) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Tuna Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Tunas List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Tuna Object
  update(record: Tuna) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Tuna>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Tuna Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
